module.exports = __webpack_public_path__ + "img/icon_3.63042609.png";